import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { AuthUtils, Theme } from 'app/shared/utils';
import { useNavigate, useNavigation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { TextInput } from 'pages/auth/components';
import { ButtonWhite, ButtonBlue } from 'pages/auth';
import { Link } from './styles';
import { brazilStates } from 'app/shared/constants';
import { useDebounce, useIsFirstRender, useService } from 'app/shared/hooks';
import { buscaGrausInstrucao } from 'app/services/grausInstrucao';
import { buscaInstituicoesEnsino } from 'app/services/instituicoesEnsino';
import { buscaPaises } from 'app/services/pais';
import { useForm, SubmitHandler, Form, useFormContext, Controller } from 'react-hook-form';
import { FormAuth } from 'pages/auth/styles';
import { cadastrarUsuario } from 'app/services/auth';
import { ErrorAuth } from 'pages/auth/styles';
import toastr from 'toastr';
import SuccessRegistration from './SuccessRegistration';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

const RegisterForm = () => {
  const navigate = useNavigate();
  const isFirstRender = useIsFirstRender()
  const [estado, setEstado] = useState();
  const [estadoOutro, setEstadoOutro] = useState('');
  const [pais, setPais] = useState();
  const [paisOutro, setPaisOutro] = useState('');
  const [instituicaoEnsinoOutro, setInstituicaoEnsinoOutro] = useState('');
  const [success, setSuccess] = useState(false);
  const [grauInstrucao, setGrauInstrucao] = useState();
  const [showSenha, setShowSenha] = useState(false);
  const [showSenhaConfirmacao, setShowSenhaConfirmacao] = useState(false);
  const [instituicaoEnsino, setInstituicaoEnsino] = useState({
    id: 373,
    label: "UNIVERSIDADE ESTADUAL DO PIAUÍ",
  });

  const [nomeInstituicaoVisual, setNomeInstituicaoVisual] = useState("");
  const [nomeInstituicao, setNomeInstituicao] = useState();
  const debouncedBuscaNomeInstituicao = useDebounce(nomeInstituicao, 300);

  const handleChangeNome = (value, type) => {
    setNomeInstituicaoVisual(value)
    if (type === 'change') {
      setNomeInstituicao(value)
    }
  }

  const { request: getGrausInstrucao, response: grausInstrucaoResponse } =
    useService(buscaGrausInstrucao);
  const { request: getInstituicoesEnsino, response: instituicoesEnsinoResponse, cancel: cancelRequestInstituicoes } =
    useService(buscaInstituicoesEnsino);
  const { request: getPaises, response: paisesResponse } =
    useService(buscaPaises);
  const { request: cadastrarUsuarioRequest, response: cadastroUsuarioResponse } = useService(
    cadastrarUsuario,
    {
      onSuccess: () => {
        setSuccess(true)
      },
    },
  );
  const { control, handleSubmit } = useForm();
  const [error, setError] = useState();

  const onSubmit = async (data, e) => {
    e.preventDefault();

    if (data.senha !== data.senhaConfirmacao) {
      toastr.error('As senhas digitadas não conferem');
      return;
    }

    const isBrasil = pais === brasilId;

    const response = await cadastrarUsuarioRequest({
      nome: data.nome,
      email: data.email,
      senha: data.senha,
      run_login: 1,
      long_token: 1,
      pais_id: pais === 'OUTRO' ? null : pais,
      pais_outro: pais === 'OUTRO' ? paisOutro : null,
      uf: isBrasil ? estado : null,
      estado_outro: isBrasil ? null : estadoOutro,
      instituicao_ensino_id: isBrasil ? (instituicaoEnsino?.id || 373) : null,
      instituicao_ensino_outro: isBrasil ? null : instituicaoEnsinoOutro,
      grau_instrucao_id: grauInstrucao,
    });
  };

  useEffect(() => {
    getGrausInstrucao();
  }, []);

  useEffect(() => {
    getPaises({ limit: 0 });
  }, []);

  useEffect(() => {
    getInstituicoesEnsino({
      page: 0,
      busca: debouncedBuscaNomeInstituicao,
    }, { cancelPrevious: true });
  }, [debouncedBuscaNomeInstituicao]);

  const grausInstrucaoResponseData = grausInstrucaoResponse.data?.data || [];
  const instituicoesEnsinoResponseData = instituicoesEnsinoResponse.data?.data || [];
  const instituicoesEnsinoDataFormatted = instituicoesEnsinoResponseData.map((instituicao) => ({
    label: instituicao.nome || '',
    id: instituicao.id,
  }));
  const paisesResponseData = paisesResponse.data || [];
  const brasilId = paisesResponseData.find((p) => p.sigla === 'BR')?.id;
  const isBrasil = pais === brasilId;

  useEffect(() => {
    if (pais === undefined && brasilId !== undefined) {
      setPais(brasilId);
    }
  }, [brasilId]);

  if (success) {
    return <SuccessRegistration />
  }

  return (
    <>
      <h1
        style={{ fontFamily: 'Roboto', textAlign: 'center', fontSize: '34px', fontWeight: '400' }}
      >
        Cadastro
      </h1>
      <FormAuth autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="nome"
          render={({ field }) => <TextInput {...field} label={'Nome'} required />}
        />
        <Controller
          control={control}
          name="email"
          render={({ field }) => <TextInput {...field} label={'Email'} required />}
        />
        <FormControl
          fullWidth
          style={{
            marginLeft: 0,
          }}
        >
          <InputLabel id="select-country">País</InputLabel>
          <Select
            required
            fullWidth
            style={{ marginLeft: 0, height: 47, fontSize: '14px', fontFamily: 'Roboto' }}
            labelId="select-country"
            id="select-country-input"
            value={pais ?? 0}
            label="País"
            placeholder="Selecione um país"
            onChange={(e) => {
              setPais(e.target.value);
            }}
          >
            <MenuItem value={0}>Selecione um país</MenuItem>
            {paisesResponseData.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {p.nome}
              </MenuItem>
            ))}
            <MenuItem value="OUTRO">Outro</MenuItem>
          </Select>
        </FormControl>
        {pais === 'OUTRO' && (
          <TextInput
            label="Digite o país"
            required
            value={paisOutro}
            onChange={(e) => setPaisOutro(e.target.value)}
          />
        )}
        {isBrasil && (
          <FormControl
            fullWidth
            style={{
              marginLeft: 0,
            }}
          >
            <InputLabel id="select-state">Estado</InputLabel>
            <Select
              required
              fullWidth
              style={{ marginLeft: 0, height: 47, fontSize: '14px', fontFamily: 'Roboto' }}
              labelId="select-state"
              id="select-state-input"
              value={estado}
              label="Estado"
              defaultValue={0}
              placeholder="Selecione um estado"
              onChange={(e) => {
                setEstado(e.target.value);
              }}
            >
              <MenuItem value={0}>Selecione um estado</MenuItem>
              {brazilStates.map((state) => (
                <MenuItem key={state.code} value={state.code}>
                  {state.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {!isBrasil && (
          <TextInput
            label="Digite o estado"
            required
            value={estadoOutro}
            onChange={(e) => setEstadoOutro(e.target.value)}
          />
        )}
        <FormControl
          fullWidth
          style={{
            marginLeft: 0,
          }}
        >
          <InputLabel id="select-leveleducation">Grau de instrução</InputLabel>
          <Select
            required
            fullWidth
            style={{ marginLeft: 0, height: 47, fontSize: '14px', fontFamily: 'Roboto' }}
            labelId="select-leveleducation"
            id="select-leveleducation-input"
            value={grauInstrucao}
            label="Grau de instrução"
            defaultValue={0}
            placeholder="Selecione uma opção"
            onChange={(e) => {
              setGrauInstrucao(e.target.value);
            }}
          >
            <MenuItem value={0}>Selecione uma opção</MenuItem>

            {grausInstrucaoResponseData.map((grauInstrucao) => (
              <MenuItem key={grauInstrucao.id} value={grauInstrucao.id}>
                {grauInstrucao.nome}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {isBrasil ? (
          <FormControl
            fullWidth
            style={{
              marginLeft: 0,
            }}
          >
            <Autocomplete
              disablePortal
              options={instituicoesEnsinoDataFormatted}
              fullWidth
              filterOptions={(options) => options}
              noOptionsText="Lista de instituições vazia"
              onChange={(e, newValue) => {
                setInstituicaoEnsino(newValue);
              }}
              inputValue={nomeInstituicaoVisual}
              onInputChange={(event, newInputValue) => {
                handleChangeNome(newInputValue, event?.type);
              }}
              renderInput={(params) => (
                <TextField
                  slotProps={instituicoesEnsinoResponse.loading ? {
                    input: {
                      endAdornment: <CircularProgress sx={{ position: 'absolute', right: "10px" }} size="20px" />,
                    }
                  } : undefined}
                  placeholder="Selecione uma IES"
                  {...params}
                  style={{ margin: 0 }}
                  label="Instituição de ensino"
                />
              )}
            />
          </FormControl>
        ) : (
          <TextInput
            label="Digite o nome da instituição"
            required
            value={instituicaoEnsinoOutro}
            onChange={(e) => setInstituicaoEnsinoOutro(e.target.value)}
          />
        )}
        <Controller
          control={control}
          name="senha"
          render={({ field }) => (
            <TextInput
              {...field}
              required
              label="Senha"
              type={showSenha ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowSenha((prev) => !prev)}
                      edge="end"
                    >
                      {showSenha ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="senhaConfirmacao"
          render={({ field }) => (
            <TextInput
              {...field}
              required
              label="Confirmar senha"
              type={showSenhaConfirmacao ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowSenhaConfirmacao((prev) => !prev)}
                      edge="end"
                    >
                      {showSenhaConfirmacao ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
        {error && <ErrorAuth>{error}</ErrorAuth>}
        <ButtonBlue fullWidth variant="contained" type={'submit'}
          disabled={cadastroUsuarioResponse.loading}
          sx={{ mt: '10px', minWidth: '140px' }}>
          {cadastroUsuarioResponse.loading ? (
            <CircularProgress size="20px" />
          ) : "Criar usuário"}
        </ButtonBlue>
        <ButtonWhite
          fullWidth
          variant="contained"
          onClick={() => {
            window.location.href = '/auth/login';
          }}
        >
          Cancelar
        </ButtonWhite>
      </FormAuth>
    </>
  );
};

export default RegisterForm;
